import ValueObject from './ValueObject';

export default class GroupId extends ValueObject {
  equals(other) {
    if (!(other instanceof GroupId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new GroupId(json);
  }
}
